import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle, GitCompare, Calculator, FileText, ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const CARDS = [
  { key: "solve", icon: AlertCircle, tone: "emerald", action: "hero" },
  { key: "compare", icon: GitCompare, tone: "sky", action: "/compare" },
  { key: "calc", icon: Calculator, tone: "amber", action: "/calculators" },
  { key: "guides", icon: FileText, tone: "indigo", action: "/guides" },
];

const TONES = {
  emerald: "bg-emerald-50 text-emerald-600",
  sky: "bg-sky-50 text-sky-600",
  amber: "bg-amber-50 text-amber-600",
  indigo: "bg-indigo-50 text-indigo-600",
};

export function FeatureCards({ onPick }) {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handle = (card) => {
    if (card.action === "hero") onPick?.("understand");
    else navigate(card.action);
  };

  return (
    <section id="features" className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{t("features_title")}</h2>
        <p className="mt-2 text-slate-500">{t("features_subtitle")}</p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((card) => {
          const Icon = card.icon;
          return (
            <button
              key={card.key}
              data-testid={`feature-card-${card.key}`}
              onClick={() => handle(card)}
              className="group card-premium flex flex-col items-start p-6 text-left"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ring-1 ring-inset ring-slate-900/5 ${TONES[card.tone]}`}>
                <Icon className="h-6 w-6" strokeWidth={2} />
              </span>
              <h3 className="font-display mt-5 text-lg font-semibold text-slate-900">{t(`feat_${card.key}`)}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-500">{t(`feat_${card.key}_desc`)}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary opacity-0 transition-opacity group-hover:opacity-100">
                {t("feature_cta")} <ArrowRight className="h-4 w-4" />
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
